<template>
  <div class="lsttable-container">
    <div v-if="type" class="table-title">
      <span>{{ type }}</span>
      <i class="el-icon-download"></i>
    </div>
    <el-table :data="list" style="width: 95%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="专业｜ ">
              <span>{{ props.row.speciality }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="部门名称｜ ">
              <span>{{ props.row.departmentName }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="部门网站｜ ">
              <span>{{ props.row.departmentUrl }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="部门代码｜ ">
              <span>{{ props.row.departmentCode }}</span>
            </el-form-item>

            <el-form-item label="工作地点｜ ">
              <span>{{ props.row.workBase }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="落户地点｜ ">
              <span>{{ props.row.settleBase }}</span>
            </el-form-item>

            <el-form-item label="招考职位｜ ">
              <span>{{ props.row.examJob }}</span>
            </el-form-item>

            <el-form-item label="招考人数｜ ">
              <span>{{ props.row.examNumber }}</span>
            </el-form-item>

            <el-form-item label="基层工作最低年限｜ ">
              <span>{{ props.row.workYear }}</span>
            </el-form-item>

            <el-form-item
              v-if="tableType == 'gk'"
              label="服务基层项目工作经历｜ "
            >
              <span>{{ props.row.workExperi }}</span>
            </el-form-item>

            <el-form-item label="学位｜ ">
              <span>{{ props.row.degree }}</span>
            </el-form-item>

            <el-form-item label="学历｜ ">
              <span>{{ props.row.qualification }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="政治面貌｜ ">
              <span>{{ props.row.face }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="考试类别｜ ">
              <span>{{ props.row.examType }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="职位分布｜ ">
              <span>{{ props.row.jobDist }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="职位属性｜ ">
              <span>{{ props.row.jobProperty }}</span>
            </el-form-item>

            <el-form-item label="职位代码｜ ">
              <span>{{ props.row.jobCode }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="职位简介｜ ">
              <span>{{ props.row.jobDesc }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="面试人员比例｜ ">
              <span>{{ props.row.examPeopleRatio }}</span>
            </el-form-item>

            <el-form-item label="机构层级｜ ">
              <span>{{ props.row.orgLevel }}</span>
            </el-form-item>

            <el-form-item label="机构性质｜ ">
              <span>{{ props.row.orgProperty }}</span>
            </el-form-item>

            <el-form-item label="用人司局｜ ">
              <span>{{ props.row.DepartmentAndBureau }}</span>
            </el-form-item>

            <el-form-item label="备注｜ ">
              <span>{{ props.row.remark }}</span>
            </el-form-item>

            <el-form-item
              v-if="tableType == 'gk'"
              label="是否在面试阶段组织专业能力测试｜ "
            >
              <span>{{ props.row.proAchiTest }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'sk'" label="咨询电话｜ ">
              <span>{{ props.row.phone }}</span>
            </el-form-item>
            <el-form-item v-if="tableType == 'gk'" label="咨询电话1｜ ">
              <span>{{ props.row.phone1 }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="咨询电话2｜ ">
              <span>{{ props.row.phone2 }}</span>
            </el-form-item>

            <el-form-item v-if="tableType == 'gk'" label="咨询电话3｜ ">
              <span>{{ props.row.phone3 }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="专业"
        min-width="120px"
        prop="speciality"
      ></el-table-column> -->
      <el-table-column
        v-if="tableType == 'gk'"
        label="部门名称"
        prop="departmentName"
      ></el-table-column>
      <el-table-column label="工作地点" prop="workBase"></el-table-column>
      <el-table-column label="招考职位" prop="examJob"></el-table-column>
      <el-table-column label="招考人数" prop="examNumber"> </el-table-column>
      <!-- <el-table-column
        label="咨询电话1"
        min-width="100px"
        prop="phone1"
      >
      </el-table-column> -->
    </el-table>
  </div>
</template>
<script>
export default {
  name: "lsftable",
  props: {
    list: {
      type: Array,
      default: [],
    },
    type: {
      type: String,
      default: "",
    },
    tableType: {
      type: String,
      default: "gk", //默认国考
    },
  },

  data() {
    return {};
  },
};
</script>
<style lang="scss">
.lsttable-container {
  .table-title {
    margin-top: 20px;
    background: #f6f8fa;
    padding: 10px;
    color: #145dff;
  }
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  // width: 144px;
  color: #99a9bf;
  padding-right: 0;
  margin-right: 10px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/official/components/lsftable.vue